import usersRoutes from './users';

export default [
  ...usersRoutes,
];
